export const externalNavigateTo = ({ href }: { href: string }) => {
  // avoid changing directly document.location api
  // In test env, jsdom does not implement all apis
  // This function is mockable and we avoid the warnings
  document.location.href = href;
};
